import { NavLink } from "react-router-dom";
import { LayoutDashboard, Hammer, CalendarClock, ClipboardList, Menu, Clock, Car, Wrench } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { isCraftsman } from "../lib/roles";

const CRAFTSMAN_ITEMS = [
    { to: "/hodiny", label: "Hodiny", icon: Clock, testid: "bottom-nav-hours" },
    { to: "/kniha-jizd", label: "Kniha jízd", icon: Car, testid: "bottom-nav-trips" },
    { to: "/naradi", label: "Nářadí", icon: Wrench, testid: "bottom-nav-tools" },
];
const ITEMS = [
    { to: "/", label: "Přehled", icon: LayoutDashboard, testid: "bottom-nav-dashboard" },
    { to: "/zakazky", label: "Zakázky", icon: Hammer, testid: "bottom-nav-jobs" },
    { to: "/planovac", label: "Plánovač", icon: CalendarClock, testid: "bottom-nav-planner" },
    { to: "/ukoly", label: "Úkoly", icon: ClipboardList, testid: "bottom-nav-tasks" },
];

export default function BottomNav({ onMore, menuOpen }) {
    const { user } = useAuth();
    const items = isCraftsman(user) ? CRAFTSMAN_ITEMS : ITEMS;
    const cls = (active) => `flex-1 flex flex-col items-center justify-center gap-1 min-h-[44px] text-[10px] font-bold uppercase tracking-wider transition-colors ${active ? "text-amber-400" : "text-slate-400 active:text-slate-100"}`;
    return (
        <nav className="bottom-nav md:hidden fixed bottom-0 inset-x-0 z-40 bg-slate-900 border-t border-slate-800 flex items-stretch px-safe" data-testid="bottom-nav">
            {items.map((i) => (
                <NavLink key={i.to} to={i.to} end={i.to === "/"} data-testid={i.testid} className={({ isActive }) => cls(isActive && !menuOpen)}>
                    <i.icon className="w-5 h-5" />
                    {i.label}
                </NavLink>
            ))}
            <button onClick={onMore} data-testid="bottom-nav-more" className={cls(menuOpen)}>
                <Menu className="w-5 h-5" />
                Více
            </button>
        </nav>
    );
}
